module.exports = __webpack_public_path__ + "static/media/People.9a813a3e.svg";